import { useState } from "react";
import { X, Menu } from "lucide-react";

export const Header = () => {
  const [bannerOpen, setBannerOpen] = useState(true);
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="fixed top-0 inset-x-0 z-50">
      {bannerOpen && (
        <div className="relative bg-[#1F2043]" data-testid="announcement-banner">
          <p className="font-body text-center text-xs md:text-sm font-light tracking-wide text-white/85 py-2.5 px-10">
            Our full website is coming soon.
          </p>
          <button
            data-testid="banner-dismiss-button"
            onClick={() => setBannerOpen(false)}
            aria-label="Dismiss announcement"
            className="absolute right-3 top-1/2 -translate-y-1/2 text-white/60 hover:text-white transition-colors duration-200 p-1"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      )}
      <header
        className="backdrop-blur-xl bg-[#FBFAF6]/85 border-b border-[#1F2043]/10"
        data-testid="site-header"
      >
        <div className="max-w-7xl mx-auto px-6 md:px-12 h-16 md:h-[4.5rem] flex items-center justify-between">
          <a href="#top" data-testid="header-logo-link" className="flex items-center gap-3">
            <img
              src="/assets/sachet-logo.webp"
              alt="Sachet Foundation logo"
              className="h-9 md:h-11 w-auto"
            />
            <span className="font-heading font-semibold text-[#1F2043] text-sm md:text-base tracking-tight">
              Sachet Foundation
            </span>
          </a>
          <nav className="hidden md:flex items-center gap-9">
            <a
              href="#our-work"
              data-testid="nav-our-work-link"
              className="font-heading text-sm font-medium text-[#3C3C3B] hover:text-[#00867A] transition-colors duration-300"
            >
              Our Work
            </a>
            <a
              href="#contact"
              data-testid="nav-contact-link"
              className="font-heading text-sm font-medium text-[#3C3C3B] hover:text-[#00867A] transition-colors duration-300"
            >
              Contact
            </a>
            <a href="#contact" data-testid="header-cta-button" className="btn-header">
              Get in touch
            </a>
          </nav>
          <button
            className="md:hidden text-[#1F2043] p-1"
            data-testid="mobile-menu-button"
            onClick={() => setMenuOpen((v) => !v)}
            aria-label="Toggle menu"
          >
            <Menu className="w-6 h-6" />
          </button>
        </div>
        {menuOpen && (
          <div
            className="md:hidden border-t border-[#1F2043]/10 bg-[#FBFAF6] px-6 py-5 flex flex-col gap-5"
            data-testid="mobile-menu"
          >
            <a
              href="#our-work"
              data-testid="mobile-nav-our-work-link"
              onClick={() => setMenuOpen(false)}
              className="font-heading text-base font-medium text-[#1F2043]"
            >
              Our Work
            </a>
            <a
              href="#contact"
              data-testid="mobile-nav-contact-link"
              onClick={() => setMenuOpen(false)}
              className="font-heading text-base font-medium text-[#1F2043]"
            >
              Contact
            </a>
            <a
              href="#contact"
              data-testid="mobile-cta-button"
              onClick={() => setMenuOpen(false)}
              className="btn-header w-fit"
            >
              Get in touch
            </a>
          </div>
        )}
      </header>
    </div>
  );
};
